<template>
	<div>
		<Layout>
			<div class="login-container" tabscope>
				<div class="login-card">
					<div class="form-section form-section-blur">
						<div class="migration-mobile">
							<div class="migration-logo-container">
								<img class="h-100 w-100 migration-img-animated" src="../../assets/migration-image.webp" />
							</div>
							<div class="migration-details">
								<div class="migration-title">
									{{ formHasError ? $t('login.f.migration-error-title') : $t('login.f.migration-title') }}
								</div>
								<div class="migration-description">
									<div v-if="message"> {{ message }}</div>
									<div v-else> {{ $t('login.f.migration-description') }}</div>
								</div>
							</div>
							<div v-if="!formHasError" class="loading-item">
								<div class="loader"></div>
							</div>
						</div>
						<form class="form-box migration-desktop" v-on:submit="submit">
							<div class="form-header">
								<div class="form-title">{{ $t('login.f.login-to-app') }}</div>
								<div class="form-description">{{ $t('login.f.enter-package-code') }}</div>
							</div>
							<div class="form-fields">
								<div class="field-container">

									<div class="field username">
										<nk-input disabled :options="customerCodeOptions" autofocus :modelValue="currentUserDetails.customerCode" startup tabindex="101"></nk-input>
										<icon class="placeholder-icon" name="user-tag" group="light" />
									</div>
								</div>
							</div>
							<div class="buttons">
								<button disabled v-if="!spinning" tabindex="102" type="submit">{{ $t('login.buttons.submit') }}
								</button>
								<div v-else class="sk-chase">
									<div class="sk-chase-dot"></div>
									<div class="sk-chase-dot"></div>
									<div class="sk-chase-dot"></div>
									<div class="sk-chase-dot"></div>
								</div>
							</div>
						</form>
					</div>
					<div class="migration-desktop business-section">
						<div class="migration-logo-container">
							<img class="h-100 w-100 migration-img-animated" src="../../assets/migration-image.webp" />
						</div>
						<div class="migration-details">
							<div class="migration-title">
								{{ formHasError ? $t('login.f.migration-error-title') : $t('login.f.migration-title') }}
							</div>
							<div class="migration-description">
								<div v-if="message"> {{ message }}</div>
								<div v-else> {{ $t('login.f.migration-description') }}</div>
							</div>
						</div>
						<div v-if="!formHasError" class="loading-item">
							<div class="loader"></div>
						</div>
					</div>
					<div class="migration-mobile business-section">
						<div class="nikan-logo-container">
							<img class="h-100 w-100" src="../../assets/logo-white.png" />
						</div>
						<div class="business-details">
							<div class="business-name">
								{{ $t('login.f.image-title') }}
							</div>
							<div class="business-description">
								<div class="business-nikan">{{ $t('login.f.nikan') }}</div>
								<div> {{ $t('login.f.business-description') }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
	import _ from 'lodash'
	import Layout from '~/views/shared/_layout-login'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import { mapGetters } from 'vuex'
	import router from '~/plugins/router'

	export default {
		components: {
			Layout,
		},
		data() {
			return {
				spinning: false,
				processing: false,
				message: '',
				customerCodeOptions: {
					mode: 'string',
					ltr: true,
					placeholder: this.$t('install.customerValidation.f.customerCode')
				},
			}
		},
		computed: {
			...mapGetters({
				currentUserDetails: 'useraccount/currentUserDetails'
			}),
			formHasError() {
				return this.message && this.message !== this.$t('install.wizard.title.migration-waiting')
			},
		},
		created() {
			// if (this.$route.query.customerCode) {
			// 	this.customerDetails.customerCode = this.$route.query.customerCode
			// }
		},
		mounted() {
			this.start()
		},
		methods: {
			start(button, e) {
				if (this.checkCustomerCode()) {
					this.message = this.$t('install.wizard.title.migration-waiting')
					let data = { customerCode: this.currentUserDetails.customerCode }
					var wait = this.$wait(this.$refs.loading, { bgColor: 'transparent' })
					this.processing = true
					post(Endpoints.getUrl('launcher.migration'), data, null, { ignoreCommercialAccess: true, silent: true }).then((res) => {
						wait.end()
						router.push({ name: 'install' })
					}).catch(err => {
						wait.end()
						this.message = err.exception.response.data.errors[0].description
					}).finally(() => {
						this.processing = false
					})
				}
			},
			checkCustomerCode() {
				if (!this.currentUserDetails || !this.currentUserDetails.customerCode) {
					// router.push({ name: 'launcher' })
					return false
				}
				return true
			},
			onPrevClicked() {
				this.$router.push({ name: 'launcher' })
			}
		},
	}
</script>

<style lang="less" src="~/styles/login.less"></style>
